const pr = (str) => {
  console.log('')
  console.log(str)
  console.log('');
  return null;
};

export default pr;